<template>
    <main class="friends-page max-width-container">
        <h1 class="form-title">Friends</h1>
        <AddFriendForm
            :errors="errors"
            :success-message="successMessage"
            @submit-form="submitForm"
        />

        <section v-if="friends.length" class="friends-section">
            <h2 class="friends-section-label">
                Friends · {{ friends.length }}
            </h2>
            <InfoRow
                v-for="friend in friends"
                :key="friend.id"
                :name="friend.name"
            >
                <span class="info-row-stat">
                    {{ friend.info.trips }} trips
                </span>
                <span class="info-row-stat">
                    {{ friend.info.bucketLists }} bucket lists
                </span>
            </InfoRow>
        </section>

        <section v-if="requests.length" class="friends-section">
            <h2 class="friends-section-label">
                Pending invites · {{ requests.length }}
            </h2>
            <InfoRow
                v-for="request in requests"
                :key="request.id"
                :name="request.name"
                class="muted"
            >
                <div class="status-badge pending">Pending</div>
            </InfoRow>
        </section>

        <div v-if="!friends.length && !requests.length" class="empty-state">
            No friends yet. Send an invite to get started.
        </div>
    </main>
</template>

<script>
import BaseFormWrapper from "js/components/base/BaseFormWrapper.js";
import AddFriendForm from "js/components/forms/AddFriendForm";
import InfoRow from "js/components/list-items/InfoRow";

import { useUserStore } from "js/stores/userStore";
import { fetch, create } from "js/lib/server";

export default {
    name: "Friends",
    components: { AddFriendForm, InfoRow },
    extends: BaseFormWrapper,
    data() {
        return {
            store: null,
            requests: [],
            friends: [],
            errors: {},
            successMessage: "",
        };
    },
    mounted() {
        this.store = useUserStore();
        this.store.getFriends().then((friends) => {
            this.friends = friends;
        });
        this.refreshFriendRequests();
    },
    methods: {
        refreshFriendRequests() {
            fetch("/api/user/friend-requests").then((response) => {
                this.requests = response.data.data;
            });
        },
        submitForm(data) {
            create("/api/invitations", data)
                .then(() => {
                    this.errors = {};
                    this.refreshFriendRequests();
                    this.successMessage = "Request sent";
                })
                .catch((err) => {
                    this.successMessage = "";
                    this.handleResponseErrors(err);
                });
        },
    },
};
</script>
